import { FC } from 'react';

import { Skeleton } from '@mui/material';

const CourseFixedGlanceSkeleton: FC = () => {
  return <Skeleton animation="wave" variant="rectangular" height={480} sx={{ borderRadius: 2 }} />;
};

export default CourseFixedGlanceSkeleton;
